import { Link } from "react-router-dom";

export default function AuthorCard({ author, testId }) {
  const initials = author.nombre.split(" ").slice(0, 2).map((w) => w[0]).join("").toUpperCase();
  return (
    <Link to={`/autores/${author.slug}`} className="group block" data-testid={testId || `author-card-${author.slug}`}>
      <div className="hv-img-zoom relative w-full aspect-square bg-[#e7e5df] grayscale group-hover:grayscale-0 transition-all duration-500">
        {author.foto ? (
          <img src={author.foto} alt={author.nombre} loading="lazy" />
        ) : (
          <div className="w-full h-full flex items-center justify-center font-serif text-5xl text-[#1f44e0]/40">{initials}</div>
        )}
      </div>
      <h3 className="font-serif text-lg font-semibold text-[#0f2544] mt-3 group-hover:text-[#1f44e0] transition-colors">{author.nombre}</h3>
      {author.biografia_corta && <p className="text-[0.8rem] text-[#8a8a83] mt-0.5 line-clamp-1">{author.biografia_corta}</p>}
    </Link>
  );
}
